"use client"
import Image, { StaticImageData } from "next/image";
import React from "react";

type WhyItem = {
  title: string;
  description: string;
  image: StaticImageData;
};

type WhyTemokProps = {
  heading: string;
  paragraph: string;
  data: WhyItem[];
};

const WhyTemok: React.FC<WhyTemokProps> = ({ heading, paragraph, data }) => (
  <div className="custMargin">
    <div className="container">
      <h1 className="fw-bold display-5 text-center textHad">{heading}</h1>
      <p className="fw-normal fs-5 textPara mb-1 text-center lh-base">{paragraph}</p>
      <div className="row">
        {data.map((item, index) => (
          <div
            key={index}
            className={`col-lg-6 col-md-12 col-12 ${
              index % 2 === 0 ? "brdRight" : ""
            } ${index < 10 ? "brdBott" : ""}`}
          >
            <div className="whyDetails d-flex align-items-center py-4">
              <div className="w-100 bd-highlight px-3">
                <h6 className="textHad fs-4 fw-bold">{item.title}</h6>
                <p className="textPara fs-6 fw-normal">{item.description}</p>
              </div>
              <div className="flex-shrink-1 bd-highlight">
                <Image src={item.image} width={100} height={100} alt="..." />
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  </div>
);

export default WhyTemok;
